import { render, staticRenderFns } from "./InvoiceBanner.vue?vue&type=template&id=7760e76e&"
import script from "./InvoiceBanner.vue?vue&type=script&lang=js&"
export * from "./InvoiceBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports